import React, { useState } from "react";
import { Col, Row, Label, Input } from "reactstrap";
import NameLoginVideo from "../../../../assets/video/login.mp4"
import logoImage from "../../../../assets/image/logocomplyer-logo.svg";
import { Link } from "react-router-dom";

export const Login = ({ onSubmit, error, loading }) => {
  const [phoneNo, setPhone] = useState("");

  return (
    <section>
      <section>
        <div className="vh-100 d-flex">
          <Row className="w-100 d-flex h-100">
            <Col lg={7} className="d-flex h-100">
              <div className="w-100 d-flex align-items-center justify-content-center h-100 bg-light">
                {/* <img
                  src={loginImage}
                  alt="Login Illustration"
                  className="img-fluid"
                  style={{ maxHeight: "100%" }}
                /> */}
  <video
                  className="img-fluid"
                  style={{ maxHeight: "100%" }}
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src={NameLoginVideo} type="video/mp4" />
                </video>

              </div>
            </Col>
            <Col className="d-flex align-items-center justify-content-center h-100">
              <div className="w-100 p-4">
                <form
                  className="bs-form"
                  onSubmit={(e) => onSubmit(phoneNo, e)}
                >
                  <div className="d-flex justify-content-center">
                    <img
                      src={logoImage}
                      alt="Login Illustration"
                      className="img-fluid"
                      style={{ width: "230px" }}
                    />
                  </div>

                  <h1
                    style={{
                      fontFamily: 'Segoe UI, sans-serif',
                      fontWeight: 600,
                      fontSize: '24px',
                      lineHeight: '100%',
                      letterSpacing: '0px',
                      color: 'rgba(26, 26, 51, 1)',
                      margin: 0,
                      paddingTop: "30px",
                        textAlign:'center'
                    }}
                  >
                    Login to continue
                  </h1>
                  <div className="input-area " style={{ marginTop: "25px" }}>
                    <Input
                      value={phoneNo}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                      type="number"
                      id="contactNumber"
                      placeholder="Enter Contact Number"
                    />
                    <i className="icon icon-phone"></i>
                  </div>
                  {error && (
                    <p
                      style={{
                        position: "absolute",
                        fontSize: "12px",
                        color: "#d73038",
                        margin: "0 0px 15px",
                        fontFamily: "roboto",
                        fontWeight: 500,
                      }}
                    >
                      {error}
                    </p>
                  )}
                  <button
                    onClick={(e) => onSubmit(phoneNo, e)}
                    className="typ-login bg-dark border-secondary text-white w-100 py-2 rounded"
                    style={{ marginTop: 25 }}
                    type="button"
                    disabled={loading}
                  >
                    {loading ? "Please wait..." : "Continue"}
                  </button>
                </form>
                <br></br>
                <div className="text-center " style={{ marginTop: "25px" }}>
                  <Link
                    to="/about-us"
                    className="text-primary text-decoration-underline custom-link"
                  >
                    About Us
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </section>
  );
};
